function compact(n: number): string {
  const trim = (value: number) => String(Math.round(value * 10) / 10);
  const thousands = Math.round(n / 100) / 10;
  if (n < 1000) return String(n);
  if (thousands < 1000) return `${trim(thousands)}k`;
  return `${trim(n / 1_000_000)}M`;
}

export function formatPilotCount(count: number): string {
  return `${compact(count)} ${count === 1 ? "pilot" : "pilots"}`;
}

export function earnedByLabel(count: number): string {
  return `${formatPilotCount(count)} ${count === 1 ? "has" : "have"} earned this`;
}
